import { useState } from "react";
import { useCAPartner } from "@/contexts/CAPartnerContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { UserPlus } from "lucide-react";

const PLAN_OPTIONS = [
  { value: "starter", label: "Starter — ₹499/mo" },
  { value: "professional", label: "Professional — ₹999/mo" },
  { value: "enterprise", label: "Enterprise — ₹1999/mo" },
];

export default function PartnerOnboardForm() {
  const { onboardClient } = useCAPartner();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [company, setCompany] = useState("");
  const [plan, setPlan] = useState("professional");

  const handleSubmit = () => {
    if (!name.trim() || !email.trim() || !company.trim()) {
      toast.error("Fill all fields");
      return;
    }
    if (!email.includes("@")) {
      toast.error("Enter a valid email");
      return;
    }
    onboardClient(name, email, company, plan);
    toast.success(`${company} onboarded on ${plan} plan!`);
    setName("");
    setEmail("");
    setCompany("");
    setPlan("professional");
  };

  return (
    <div className="p-5 rounded-lg bg-card border border-accent/30 shadow-card bg-gradient-to-br from-accent/5 to-transparent">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-xl bg-accent/10 flex items-center justify-center">
          <UserPlus className="h-5 w-5 text-accent" />
        </div>
        <div>
          <h3 className="text-sm font-semibold text-foreground">Onboard New Client</h3>
          <p className="text-xs text-muted-foreground">Add a client to start earning commissions</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-3">
        <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Client name" />
        <Input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Client email" type="email" />
        <Input value={company} onChange={(e) => setCompany(e.target.value)} placeholder="Company name" />
        <select
          value={plan}
          onChange={(e) => setPlan(e.target.value)}
          className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          {PLAN_OPTIONS.map((p) => (
            <option key={p.value} value={p.value}>{p.label}</option>
          ))}
        </select>
      </div>

      <Button onClick={handleSubmit} className="gap-2">
        <UserPlus className="h-4 w-4" /> Onboard Client
      </Button>
    </div>
  );
}
